import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
const StyledContainer = styled.div `
    padding: 20px;
    border: 1px solid ${color.gray.light};
    border-radius: 6px;
    margin-bottom: 30px;
`;
const FormGroup = ({ children }) => (React.createElement(StyledContainer, null, children));
export default FormGroup;
